import { type Mutation, type Query } from '@pkg/graphql/codegen/graphql';
import { yatsHide, yatsShow } from '@pkg/graphql/mutations';
import { getUserYats } from '@pkg/graphql/queries';

import { apiReturnResults, type BaseParams, graphqlReturnResults, Request } from '@app/client';

import { type HideYatsParams, type QueryYatsParams, type ShowYatsParams } from './request.types';

async function hideCollectibles(params: HideYatsParams): Promise<Mutation> {
    return Request.graphqlMutation({
        ...params,
        query: yatsHide,
        apiSettingsType: 'marketplace',
    });
}

async function showCollectibles(params: ShowYatsParams): Promise<Mutation> {
    return Request.graphqlMutation({
        ...params,
        query: yatsShow,
        apiSettingsType: 'marketplace',
    });
}

export const callHideYats = (params: { variables: HideYatsParams }) => apiReturnResults(hideCollectibles, params);
export const callShowYats = (params: { variables: ShowYatsParams }) => apiReturnResults(showCollectibles, params);

async function handleGetUserYats(params: BaseParams & { variables: QueryYatsParams }): Promise<Query> {
    return Request.graphqlQuery({
        ...params,
        query: getUserYats,
        apiSettingsType: 'marketplace',
    });
}

export const callGetUserYats = async (params: BaseParams & { variables: QueryYatsParams }): Promise<Query> =>
    graphqlReturnResults(handleGetUserYats, params);
